import styled from "styled-components";

export const StyledPaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 97%;
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  color: #5b5e63;
  padding-block: 25px;
`;

export const StyledPaginationLink = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #5b5e63;
  height: 30px;
  width: 30px;
  text-decoration: none;
  transition: background-color 0.2s;
  cursor: pointer;
  border-radius: 50%;
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  /* text-align: left; */
  gap: 10px;
  &.active {
    background-color: #f7f7f7;
    color: #5b5e63;
  }

  &.disabled {
    opacity: 0.2;
  }

  &:hover:not(.active) {
    border-radius: 50%;
  }
`;
export const StyledPaginationNumbers = styled.div`
  display: flex;
  gap: 5px;
  font-family: Euclid Circular B;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  color: #5b5e63;
`;
export const StyledPaginationIcon = styled.span`
  font-size: 18px;
  margin-left: 80px;
  color: #5b5e63;
`;
export const StyledPaginationIconR = styled.span`
  font-size: 18px;
  margin-right: -10px;
  color: #5b5e63;
`;
